import React from 'react';
import './ExpandingFab.css';

const ExpandingFab = ({ isExpanded, onFabClick, onConfirmClick, onCancelClick }) => {
  const handleCancelClick = (e) => {
    e.stopPropagation();
    onCancelClick();
  };

  const handleConfirmClick = (e) => {
    e.stopPropagation();
    onConfirmClick();
  };

  return (
    <div className="fab-container">
      {isExpanded ? (
        <div className="fab-options">
          <button className="fab-option confirm" onClick={handleConfirmClick}>
            ✓
          </button>
          <button className="fab-option cancel" onClick={handleCancelClick}>
            ×
          </button>
        </div>
      ) : (
        <button className="fab-main" onClick={onFabClick}>
          +
        </button>
      )}
    </div>
  );
};

export default ExpandingFab;
